import { defineComponent as _defineComponent } from 'vue'
import { computed } from "@vue/reactivity";
import ButtonInputWithTimer from "./ButtonInputWithTimer.vue";
import { PropType, inject, onBeforeUnmount, ref, watch } from "vue";
import { useUserStore } from "@/stores/userStore";
import {
  PROVIDE_KEY_SHOW_ERROR_MODAL,
  ShowErrorModal,
  TimerStatus,
} from "@/types";


const __default__ = {
  name: "EmailCertInput",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  name: {
    type: String,
    required: true,
  },
  value: {
    type: String,
    default: "",
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  rules: {
    type: Object,
  },
  parentValue: {
    type: String,
    default: "",
  },
  timerStatus: {
    type: String as PropType<TimerStatus>,
  },
  required: {
    type: Boolean,
    default: true,
  },
},
  emits: ["update:value", "updateTimerStatus", "verificationSuccess"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props;

const emit = __emit;

const inputValue = computed({
  get(): string {
    return props.value as string;
  },
  set(inputValue: string) {
    resetCheckVerification();
    emit("update:value", inputValue);
  },
});

const showErrorModal = inject(PROVIDE_KEY_SHOW_ERROR_MODAL) as ShowErrorModal;

const userStore = useUserStore();

const email = computed(() => props.parentValue);

const buttonInputWithTimer = ref<InstanceType<typeof ButtonInputWithTimer>>();
const startTimer = () => {
  buttonInputWithTimer.value?.startTimer();
  emit("updateTimerStatus", TimerStatus.PROGRESS);
};

const emailVerificationSuccessMsg = ref("");
const emailVerificationErrorMsg = ref("");
// 이메일 인증번호 확인하기
const checkEmailVerificationCode = async () => {
  emailVerificationSuccessMsg.value = "";
  emailVerificationErrorMsg.value = "";

  const checkEmailVerificationResult =
    await userStore.checkEmailVerificationCode(email.value, inputValue.value);

  if (checkEmailVerificationResult.isSuccess) {
    emailVerificationSuccessMsg.value = "인증이 완료되었습니다.";
    buttonInputWithTimer.value?.stopTimer();
    emit("verificationSuccess");
    return;
  }

  if (checkEmailVerificationResult.resultCode === 401000311) {
    emailVerificationErrorMsg.value = "인증번호가 일치하지 않습니다.";
    return;
  }

  showErrorModal(
    "이메일 인증번호 확인 오류",
    checkEmailVerificationResult.errorMessage,
    checkEmailVerificationResult.resultCode,
    checkEmailVerificationResult.errorTime
  );
};

const resetCheckVerification = () => {
  emailVerificationSuccessMsg.value = "";
  emailVerificationErrorMsg.value = "";
};

watch(
  () => props.timerStatus,
  (timerStatus) => {
    if (timerStatus === TimerStatus.START) {
      startTimer();
    }
  }
);

onBeforeUnmount(() => {
  buttonInputWithTimer.value?.stopTimer();
});

const __returned__ = { props, emit, inputValue, showErrorModal, userStore, email, buttonInputWithTimer, startTimer, emailVerificationSuccessMsg, emailVerificationErrorMsg, checkEmailVerificationCode, resetCheckVerification, ButtonInputWithTimer }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})